import { ContentComponent, ContentComponents } from "theme/libs/wordpress/utils/cmsComponentHandlers";

import PropTypes from "prop-types";
import React from "react";
import loadable from "@loadable/component";

const FlexibleBlock = loadable(() => import("theme/libs/wordpress/content/cmsBlocks/FlexibleBlock"));
const TextSectionBlock = loadable(() => import("theme/libs/wordpress/content/cmsBlocks/TextSectionBlock"));
const FAQBlock = loadable(() => import("theme/libs/wordpress/content/cmsBlocks/FAQBlock"));
const TextHeroBlock = loadable(() => import("theme/libs/wordpress/content/cmsBlocks/TextHeroBlock"));

// Object of available blocks and their keys
const availableContentBlocks = {
    flexible: FlexibleBlock,
    flexible_article_block: FlexibleBlock,
    flexible_small: FlexibleBlock,
    image: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/ImageBlock")),
    image_article_block: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/ImageColumnBlock")),
    newsletter: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/NewsletterBlock")),
    video_player: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/VideoPlayerBlock")),
    category_slider: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/CategorySliderBlock")),
    text_block: TextSectionBlock,
    text_article_block: TextSectionBlock,
    text_hero: TextHeroBlock,
    faq: FAQBlock,
    faq_article_block: FAQBlock,
    empty_placeholder: () => <div />,
    iframe: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/IframeBlock")),
    product_promotion: loadable(() => import("theme/libs/wordpress/content/cmsBlocks/ProductPromotionBlock")),
};

/**
 * Accepts raw block data from the cms and tries to match the data to a cmsBlock.
 * If a match is found the cmsBlock is returned and rendered.
 * @param {(object|object[])} data - Raw block data from the cms. Can be a object or an array of objects.
 * @param {...*} rest - All additional props will be forwarded to the cmsBlock.
 */

const CmsBlocks = ({ data, ...rest }) => {
    if (!data) {
        return null;
    } else if (Array.isArray(data)) {
        return <ContentComponents data={data} availableContent={availableContentBlocks} {...rest} />;
    }
    return <ContentComponent data={data} availableContent={availableContentBlocks} {...rest} />;
};

CmsBlocks.propTypes = {
    data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
};

CmsBlocks.defaultProps = {
    data: undefined,
};

export default CmsBlocks;
